import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs/internal/firstValueFrom";
import { ApiBaseUrls, ApiControllers } from "../../constants/constants";
import { ServiceResultModel } from "../../models/service/service-result.model";
import { ServiceUtilities } from "../../utilities/service.utilities";
import { APISanitizerUtilities } from "../../utilities/api-sanitizer.utilities";
import { SentEmailModel } from "../../models/data/sent-email.model";
import { SentEmailFilter } from "../../filters/sent-email.filter";
import { PaginatedListModel } from "../../models/service/paginated-list.model";
import { PaginationResponseHeader } from "../../models/service/pagination-response-header.model";

@Injectable({
  providedIn: 'root'
})
export class SentEmailService {
  private apiPath: string = `${ApiBaseUrls.MESSAGING()}${ApiControllers.MESSAGES()}`;

  constructor(private httpClient: HttpClient) { }

  public async searchSentEmails(
    filter: SentEmailFilter,
    orderBy?: string,
    skip?: number,
    take?: number
  ): Promise<ServiceResultModel<PaginatedListModel<SentEmailModel>>> {
    try {
      const encodedOrderBy = orderBy ? encodeURIComponent(orderBy) : '';
      const requestUrl = `${this.apiPath}/filter?orderBy=${encodedOrderBy}&skip=${skip ?? 0}&take=${take ?? ''}`;

      const response = await firstValueFrom(
        this.httpClient.post<SentEmailModel[]>(
          requestUrl,
          JSON.stringify(APISanitizerUtilities.sanitizePayload<SentEmailFilter>(filter)),
          { observe: "response", headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } }
        )
      );

      const paginationHeader: PaginationResponseHeader = JSON.parse(response.headers.get("x-pagination")!);
      const paginatedList: PaginatedListModel<SentEmailModel> = {
        data: <SentEmailModel[]>response.body?.valueOf(),
        total: paginationHeader?.total,
        skip: paginationHeader?.skip,
        take: paginationHeader?.take,
        hasPrevious: paginationHeader?.hasPrevious,
        hasNext: paginationHeader?.hasNext
      };

      return <ServiceResultModel>{ data: paginatedList, success: true, statusCode: response.status };
    } catch (error) {
      return ServiceUtilities.handleServiceException(error);
    }
  }
}
